<template lang="pug">
div.wrapper.flex.items-center.justify-center
  div.w-full.flex.items-center.justify-center.flex-col
    svg(xmlns='http://www.w3.org/2000/svg' width='180' height='180' fill='#DBE1EC' viewBox='0 0 48 48')
      path(d='M22 30h4v4h-4zm0-16h4v12h-4zm1.99-10C12.94 4 4 12.95 4 24s8.94 20 19.99 20S44 35.05 44 24 35.04 4 23.99 4zM24 40c-8.84 0-16-7.16-16-16S15.16 8 24 8s16 7.16 16 16-7.16 16-16 16z')
    .title
      h5 {{$t('err-code')}} {{statusCode}}
      h1 {{ statusMessage }}
    .description
      NuxtLink.error-link(@click="handleError") {{$t('back-home')}}
</template>
  
<script setup lang="ts">
// const $t = useI18n().t
const error = ref({
  statusCode: 404,
  statusMessage: 'Page Not Found'
})

useHead({
  title: error.value?.statusMessage || `${error.value?.statusCode}`,
  meta: [
    {
      name: 'robots',
      content: 'noindex, nofollow, noarchive, nosnippet',
    },
  ]
})

const handleError = () => navigateTo('/')

const statusCode = computed(() => {
  return error.value?.statusCode || error.value?.statusMessage || 500
})
const statusMessage = computed(() => {
  return error.value?.statusMessage
})
</script>

<style lang="postcss" scoped>
.wrapper {
  /* max-width: var(--primary-max-width); */
  /* height: 100vh; */
  width: 100vw;

  .title {
    h5 {
      color: #7f828b;
      font-weight: 300;
      margin-bottom: 1rem;
    }

    h1 {
      font-size: 2rem;
      line-height: 2rem;
    }

    margin-top: 1rem;
    margin-bottom: 1rem;
  }

  .description {
    color: var(--secondary-color);
    font-weight: bold;
    line-height: 1.5rem;
    margin-bottom: 0.625rem;
    margin-top: 2rem;
  }

  .content {
    h3 {
      font-weight: 500;
      white-space: pre-wrap;
      /* css-3 */
      word-wrap: break-word;
    }
  }

  a {
    color: #7f828b !important;
    text-decoration: none;
  }

  .logo {
    position: fixed;
    left: 12px;
    bottom: 12px;
  }

  .error-img {
    width: 100%;
  }
}
</style>
  
